import Login from "../Login";

const MobileLogin = () => {
  return (
    <div className="h-100%">
      <Login />
    </div>
  );
};

export default MobileLogin;
